import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/index.js'
import createPersiste from 'vue-savedata'
Vue.use(Vuex)
//引入仓库
const store = new Vuex.Store({
  modules: {
    app
  },
  plugins: [createPersiste()],
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js